import emailjs from "emailjs-com";
import React, { useState } from "react";
import "./Contact.css";

const Contact = () => {
  const [loading, setLoading] = useState(false);
  const [consent, setConsent] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    if (!consent) {
      alert("Please agree to receive text messages.");
      return;
    }

    setLoading(true);

    emailjs
      .sendForm(
        "service_r0plfhi",
        "template_u09h6hd",
        e.target,
        "user_kftkAVN4w3dLOjj83aAtF"
      )
      .then(() => {
        e.target.reset();
        setConsent(false);
        alert("Message sent successfully!");
      })
      .catch(() => alert("Failed to send message."))
      .finally(() => setLoading(false));
  };

  return (
    <section id="Contact" className="contact-story">
      <div className="contact-intro">
        <h2>Let’s Start a Conversation</h2>
        <p>
          Whether you have a question, a work order, or need a reliable technology and operations partner — our team is ready to help.
        </p>
      </div>

      <div className="contact-details">
        <div>
          <strong>Address</strong>
          <span>145, Eastern Plus Commercial Complex, 7th floor, Suite-19, Shantinagar, Dhaka-1217</span>
        </div>
        <div>
          <strong>Phone</strong>
          <span>+880 1605-956596</span>
        </div>
        <div>
          <strong>Email</strong>
          <span>stantechsolutionsltd@gmail.com</span>
        </div>
      </div>

      <form className="contact-flow-form" onSubmit={sendEmail}>
        
          <input type="text" name="first_name" placeholder="First name" required />
          <input type="text" name="last_name" placeholder="Last name" required />
        

        <input type="text" name="company" placeholder="Company (optional)" />
        <input type="email" name="email" placeholder="Email address" required />
        <input type="tel" name="phone" placeholder="Phone number" required />

        <textarea
          name="message"
          rows="5"
          placeholder="Tell us how we can help…"
          required
        />

        <div className="consent-line">
          <input
            type="checkbox"
            id="consent"
            checked={consent}
            onChange={() => setConsent(!consent)}
          />
          <label htmlFor="consent">
            I agree to receive SMS messages. Consent is not a condition of
            purchase. Reply STOP to cancel.
            <br />
            {/* <a href="/privacypolicy.html" target="_blank" rel="noreferrer">
              Privacy Policy
            </a>{" "}
            |{" "}
            <a href="/privacy.html" target="_blank" rel="noreferrer">
              Terms & Conditions
            </a>{" "}
            |{" "}
            <a href="/refund.html" target="_blank" rel="noreferrer">
              Refund Policy
            </a> */}
          </label>
        </div>

        <button type="submit" disabled={loading}>
          {loading ? "Sending…" : "Send Message"}
        </button>
      </form>

      <div className="contact-footer">
        <div className="payments">
          <span>Payment Partners</span>
          <div className="icons">
            <i className="fab fa-cc-visa"></i>
            <i className="fab fa-cc-mastercard"></i>
            <i className="fab fa-cc-paypal"></i>
            <i className="fab fa-cc-stripe"></i>
          </div>
        </div>

        <div className="social">
          <span>Connect with us</span>
          <a
    href="https://www.linkedin.com/company/stantech-solutions-ltd"
    aria-label="LinkedIn"
    target="_blank"
    rel="noopener noreferrer"
  >
    <i className="fab fa-linkedin-in"></i>
  </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
